<template>
    <v-container fluid>
        <v-card rounded min-height="100vw">
            <p> Dark room</p>
        </v-card>
    </v-container>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>

</style>